/**
 * Returns an object from a query params strings
 * @param {string} queryParamsString - query params to be converted into an object.
 * Example: "?error=server_error&error_description=unexpected_error_occurred"
 * To: {error: 'server_error', error_description: 'unexpected_error_occurred' }
 */
var queryParamsToObject = function (queryParamsString) {
    var searchParams = queryParamsString;
    if (queryParamsString.includes("?")) {
        searchParams = searchParams.substring(1);
    }
    var result = {};
    searchParams.split("&").forEach(function (param) {
        var _a = param.split("="), key = _a[0], value = _a[1];
        result[key] = value;
    });
    return result;
};
export default queryParamsToObject;
